var _g, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 94"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 81",
    fill: "none",
    d: "M0 0h20v20H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 19",
    d: "M15 9.167v1.667h3.333V9.167z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 20",
    d: "M13.333 14.675c.8.592 1.842 1.375 2.667 1.992.333-.442.667-.892 1-1.333-.825-.617-1.867-1.4-2.667-2-.333.449-.667.899-1 1.341z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 21",
    d: "M17 4.666c-.333-.442-.667-.892-1-1.333-.825.617-1.867 1.4-2.667 2 .333.442.667.892 1 1.333.8-.6 1.842-1.375 2.667-2z",
    fill: "#666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 22",
    d: "M3.334 7.5a1.672 1.672 0 00-1.667 1.667v1.667A1.672 1.672 0 003.334 12.5h.833v3.333h1.667V12.5h.833l4.167 2.5V5L6.667 7.5zm4.191 1.425l1.642-.983v4.117l-1.642-.983-.4-.242H3.334V9.167h3.791z",
    fill: "#666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 23",
    d: "M12.917 10a3.733 3.733 0 00-1.25-2.792v5.575A3.7 3.7 0 0012.917 10z",
    fill: "#666"
  })));
}

export default SvgReportIcon;